import { StringLiteral } from "typescript";

export namespace APIrequest {
  export class MerchantRegistration {
    firstName?: string;
    lastName?: string;
    email?: string;
    rcNo?: StringLiteral;
    phoneNumber?: string;
    businessName?: string;
    businessAddress?: string;
    businessEmail?: string;
    businessPhoneNumber?: string;
  }

  export class CreateRoleRequest {
    name?: string;
    permissionNames?: string[];
  }
  export class CreateMerchantUser {
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    roleId?: string;
  }
  export class Dashboard {
    day?: string;
  }

  export class ReportSearch {
    requestId?: string;
    merchantId?: string;
    productName?: string;
    billerName?: string;
    serviceProvider?: string;
    status?: string;
    fromDate?: string;
    toDate?: string;
    size?: number;
    page?: number;
  }

  export class SettlementSearch {
    billerName?: string;
    fromDate?: string;
    merchantId?: string;
    page?: number;
    productName?: string;
    referenceNumber?: string;
    requestId?: string;
    serviceProvider?: string;
    size?: number;
    status?: string;
    toDate?: string;
    walletReferenceNumber?: string;
  }

  export class WalletSearch {
    fromDate?: string;
    page?: number;
    size?: number;
    toDate?: string;
    transactionRef?: string;
    transactionType?: string;
    walletNumber?: string;
  }

  export class walletAlert {
    active?: boolean;
    amount?: number;
    recipientEmails?: string[];
  }
  export class BillerRequest {
    billersId?: number[];
  }

  export class AuditLogSearch {
    action?: string;
    actionName?: string;
    fromDate?: string;
    page?: number;
    performedBy?: string;
    size?: number;
    toDate?: string;
    merchantId?: number;
  }

  export class UpdateMerchantProfile {
    businessAddress?: string;
    businessEmail?: string;
    businessName?: string;
    businessPhoneNumber?: string;
    email?: string;
    firstName?: string;
    kycTierId?: number;
    lastName?: string;
    phoneNumber?: string;
    rcNo?: string;
  }

  export class KycFormRequest {
    boardResolutionApproval?: string;
    bvn?: string;
    cac2AndCac7?: string;
    certificateOfIncorporation?: string;
    dateOfBirth?: string;
    directorBvn?: string;
    directorName?: string;
    directorValidIdCard?: string;
    emailAddress?: string;
    fullName?: string;
    gazette?: string;
    gender?: string;
    governmentIssuedIdCard?: string;
    homeAddress?: string;
    memart?: string;
    phoneNumber?: string;
    placeOfBirth?: string;
    utilityBill?: string;
    image?: string;
    imageType?: string;
  }

  export class Details {
    serviceCode?: string;
    account?: string;
    accountNumber?: string;
    accountType?: string;
    phoneNumber?: string;
    amount?: number;
    billerCode?: string
    uniqueCode: any;
    name?: string;
    address?: string;
    arrears?: string;
    tariffName?: string;
    rate?: string;
    minimumVending?: string;
    email?: string;
    noOfCandidate?: any;
    noOfMonth?: any;
    profileCode?: string;
    profileType?: string;
    surname?: string;
    othernames?: string;
    dob?: string;
    gender?: string;
    city?: string;
    state?: string;
    postalAddress?: string;
    chasisNumber?: string;
    engineNumber?: string;
    makeId?: string;
    modelId?: string;
    registrationNumber?: string;
    bodyType?: string;
    color?: string;
    manuYear?: string;
    value?: string;
  }

  export class TransactionPin {
    pin?: string;
  }

  export class CreateTransactionPin {
    pin?: string;
    confirmPin?: string;
  }

  export class ChangeTransactionPin {
    pin?: string;
    confirmPin?: string;
    oldPin?: string;
  }

  export class FilterProductRequest {
    billerName?: string;
    categoryName?: string;
    name?: string;
    productCode?: string;
    status?: string;
  }

  export class BulkUpload {
    file?: any;
  }
}
